import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { TrendingUp, TrendingDown, Users } from 'lucide-react';
import { productsAPI } from '../../lib/api';

export default function StockTicker() {
  const [deals, setDeals] = useState([]);
  const [buyerCounts, setBuyerCounts] = useState({});

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await productsAPI.getAll();
        const products = res.data.slice(0, 10).map(p => ({
          id: p.id,
          symbol: p.vendor_name?.slice(0, 4).toUpperCase() || p.category?.slice(0, 4).toUpperCase() || 'DEAL',
          name: p.name.length > 14 ? p.name.slice(0, 14) + '...' : p.name,
          price: p.price,
          change: -(Math.floor(Math.random() * 35) + 10),
          buyers: Math.floor(Math.random() * 40) + 5,
        }));
        if (products.length > 0) setDeals(products);
      } catch {
        // fallback static deals
        setDeals([
          { id: null, symbol: 'NIKE', name: 'Air Max 95', price: 107.99, change: -40, buyers: 23 },
          { id: null, symbol: 'APPL', name: 'Watch SE', price: 187.49, change: -25, buyers: 18 },
          { id: null, symbol: 'SONY', name: 'WH-1000XM5', price: 227.49, change: -35, buyers: 12 },
          { id: null, symbol: 'DYSN', name: 'V15 Detect', price: 559.99, change: -20, buyers: 8 },
          { id: null, symbol: 'SAMG', name: 'Galaxy S24', price: 699.99, change: -30, buyers: 31 },
        ]);
      }
    };
    fetchProducts();
  }, []);

  useEffect(() => {
    if (deals.length === 0) return;
    const interval = setInterval(() => {
      setBuyerCounts(prev => {
        const updated = { ...prev };
        deals.forEach(deal => {
          if (Math.random() > 0.7) {
            updated[deal.symbol] = (updated[deal.symbol] || deal.buyers) + Math.floor(Math.random() * 3);
          }
        });
        return updated;
      });
    }, 2000);
    return () => clearInterval(interval);
  }, [deals]);

  if (deals.length === 0) return null;

  const tickerItems = [...deals, ...deals];

  return (
    <div className="stock-ticker py-2">
      <div className="stock-ticker-content">
        {tickerItems.map((deal, idx) => {
          const inner = (
            <div className="flex items-center gap-3">
              <span className="font-display font-bold text-white text-sm">{deal.symbol}</span>
              <span className="text-zinc-400 text-xs hidden sm:block">{deal.name}</span>
              <span className="font-mono font-bold text-white">${deal.price.toFixed(2)}</span>
              <span className={`flex items-center gap-1 text-sm font-bold ${deal.change < 0 ? 'ticker-up' : 'ticker-down'}`}>
                {deal.change < 0 ? <TrendingDown size={12} /> : <TrendingUp size={12} />}
                {Math.abs(deal.change)}%
              </span>
              <span className="flex items-center gap-1 text-xs text-zinc-400">
                <Users size={10} />
                {buyerCounts[deal.symbol] || deal.buyers}
              </span>
            </div>
          );

          return deal.id ? (
            <Link
              key={`${deal.symbol}-${idx}`}
              to={`/product/${deal.id}`}
              className="ticker-item hover:bg-white/10 transition-colors rounded px-2 cursor-pointer"
              data-testid={`ticker-item-${idx}`}
            >
              {inner}
            </Link>
          ) : (
            <div key={`${deal.symbol}-${idx}`} className="ticker-item px-2">
              {inner}
            </div>
          );
        })}
      </div>
    </div>
  );
}
